import type { OfferTrackingConfig } from '@ocx/data-offers';

export type OfferImpressionTrackingContext = {
  activateOfferId: string;
  trackingId: string;
  isActivityLogIncludedInAltriaDDM: boolean;
};

export type OfferImpressionTrackingSource = {
  id: string;
  trackingConfig: OfferTrackingConfig | null;
};

export const impressionTrackingCtxFromOffer = (
  offer: OfferImpressionTrackingSource,
): OfferImpressionTrackingContext | null =>
  offer.trackingConfig
    ? {
        activateOfferId: offer.id,
        trackingId: offer.trackingConfig.trackingId,
        isActivityLogIncludedInAltriaDDM: offer.trackingConfig.isActivityLogIncludedInAltriaDDM,
      }
    : null;
